<template>
  <qb-sidebar
    :name="name"
    title="Cell"
    size="sm"
    :loading="isLoading"
    @open="open"
  >
    <div class="mx-4">
      <vs-row vs-type="flex" vs-justify="center" class="mb-4">
        <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="10">
          <vs-input
            class="inputx"
            :placeholder="$t('name')"
            v-model="cellName"
          />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="end" vs-align="center" vs-w="2">
          <vs-button
            color="success"
            type="filled"
            class="w-full mx-2"
            icon-pack="feather"
            icon="icon-plus"
            @click="add"
          ></vs-button>
        </vs-col>
      </vs-row>
      <vs-divider
        color="danger"
        :style="[{ 'font-size': '16px' }, { 'font-weight': 'bold' }]"
        >{{ $t('clients') | capitalize }}</vs-divider
      >
      <vs-row class="mb-4">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <client-list
            v-model="cellClients"
            :clients="clients"
            @remove="remove"
            class="w-full"
          />
        </vs-col>
      </vs-row>
      <vs-divider
        color="danger"
        :style="[{ 'font-size': '16px' }, { 'font-weight': 'bold' }]"
        >{{ $t('users') | capitalize }}</vs-divider
      >
      <vs-row class="mb-4">
        <vs-col vs-xs="12">
          <v-select
            v-model="cellUsers"
            multiple
            :options="users"
            :reduce="(option) => option.userId"
            label="name"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-justify="center">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="primary"
            type="filled"
            class="w-full"
            icon-pack="feather"
            icon="icon-save"
            :disabled="disabledSubmit"
            @click="handleSubmit"
            >{{ $t('save') | capitalize }}</vs-button
          >
        </vs-col>
      </vs-row>
    </div>
  </qb-sidebar>
</template>
<script>
import QbSidebar from '@/views/qb-components/QbSidebar'
import ClientList from '@/views/modules/dashboard/cells/components/ClientList.vue'
import dashboard from '@/http/requests/dashboard'
import vSelect from 'vue-select'

export default {
  name: 'ehs-details',
  components: {
    QbSidebar,
    ClientList,
    'v-select': vSelect,
  },
  props: {
    cellId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      name: 'sidebar-cell',
      title: 'titulo',
      loadings: {
        users: false,
        clients: false,
        cell: false,
        submit: false,
      },
      cellName: '',
      cellUsers: [],
      cellClients: [],
      clients: [],
      users: [],
    }
  },
  computed: {
    disabledSubmit() {
      return this.cellName.length <= 3 || this.cellClients.length === 0
    },
    isLoading() {
      return (
        this.loadings.users ||
        this.loadings.clients ||
        this.loadings.submit ||
        this.loadings.cell
      )
    },
  },
  methods: {
    add() {
      console.log();
      this.cellClients = [
        ...this.cellClients,
        { clientId:this.clients[0].ClientId, color: '#DDE6E8' },
      ]
    },
    remove(index) {
      this.cellClients.splice(index, 1)
    },
    getClients() {
      this.loadings.clients = true
      dashboard
        .getClients()
        .then((res) => {
          this.clients = res.data.clients
          this.loadings.clients = false
        })
        .catch((res) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
          this.loadings.clients = false
        })
    },
    getUsers() {
      this.loadings.users = true
      dashboard
        .getUsers()
        .then((res) => {
          this.users = res.data.users
          this.loadings.users = false
        })
        .catch((res) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
          this.loadings.users = false
        })
    },
    getCell() {
      this.loadings.cell = true
      dashboard
        .getCell({ cellId: this.cellId })
        .then((res) => {
          this.cellName = res.data.cell.name
          this.cellClients = res.data.clients.map((el) => ({
            clientId: el.client_id,
            color: el.color,
          }))
          this.cellUsers = res.data.users.map(({ user_id }) => user_id)
          this.loadings.cell = false
        })
        .catch((res) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
          this.loadings.cell = false
        })
    },
    handleSubmit() {
      if (this.cellId === null) {
        this.save()
      } else {
        console.log('update')
        this.update()
      }
    },
    save() {
      this.loadings.submit = true
      let data = {
        cellName: this.cellName,
        cellClients: this.cellClients,
        cellUsers: this.cellUsers,
      }
      dashboard
        .saveCell(data)
        .then((res) => {
          this.$vs.notify({
            color: 'success',
            title: 'CELL',
            text: 'ADDED',
          })
          this.$emit('reload')
          this.$store.dispatch('toggleSidebar', '')
          this.loadings.submit = false
        })
        .catch((res) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
          this.loadings.submit = false
        })
    },
    update() {
      this.loadings.submit = true
      let data = {
        cellId: this.cellId,
        cellName: this.cellName,
        cellClients: this.cellClients,
        cellUsers: this.cellUsers,
      }
      dashboard
        .updateCell(data)
        .then((res) => {
           this.$vs.notify({
            color: 'success',
            title: 'CELL',
            text: 'UPDATED',
          })
          this.$emit('reload')
          this.$store.dispatch('toggleSidebar', '')
          this.loadings.submit = false
        })
        .catch((res) => {
          this.$vs.notify({
            color: 'danger',
            title: 'Alert',
            text: 'SERVER ERROR',
          })
          this.loadings.submit = false
        })
    },
    open() {
      this.cellName = ''
      this.cellUsers = []
      this.cellClients = []
      console.log('log', this.cellId)
      if (this.cellId !== null) {
        this.getCell()
      }
    },
  },
  mounted() {
    this.getClients()
    this.getUsers()
  },
}
</script>

<style>
</style>
